import { createFileRoute } from '@tanstack/react-router';

import { TacticalUAVPageContent } from '~/components/products/tactical-drones/TacticalUAVPageContent';
import { DEFAULT_LOCALE } from '~/utils/i18n';

const TacticalUAVPage = () => {
  return <TacticalUAVPageContent />;
};

export const Route = createFileRoute('/products/tactical-drones')({
  beforeLoad: ({ context }) => ({
    ...context,
    locale: DEFAULT_LOCALE,
  }),
  component: TacticalUAVPage,
});
